var EventManager =
{
    events: [],

    binders: $.Enumerable.Empty().ToDictionary(),

    bind: function (event, fn) {

        var binder = this.binders.Get(event);
        if (binder == undefined) {
            this.events.push(event);
            this.binders.Add(event, []);
            this.binders.Get(event).push(fn);
        }
        else {
            binder.push(fn);
        }

    },

    unbind: function (event) {
        var binder = this.binders.Get(event);
        if (binder) {
            binder = [];
        }
    },

    trigger: function (event, args) {
        var binder = this.binders.Get(event);
        if (binder) {
            $(binder).each(function (i, item) {
                if (typeof (item) == 'function')
                    item.apply(null, args || []);
            });
        }
    }
}